import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "./index.css";
import "react-toastify/dist/ReactToastify.min.css";

import App from "./App";

import Home from "./routes/Home";
import Pages from "./routes/Pages";
import NotFound from "./routes/NotFound";
import Completed from "./routes/Completed";
import ShoppingCart from "./routes/ShoppingCart";
import UserState from "./context/user/UserState";
import ProductState from "./context/product/ProductState";
import Dummy from "./routes/Dummy";

ReactDOM.render(
  <React.StrictMode>
    <UserState>
      <ProductState>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />}>
              <Route index path="/" element={<Navigate to="home/pages/shopping-cart" />} />

              <Route path="home" element={<Home />}>
                <Route index element={<Dummy />} />

                <Route path="pages" element={<Pages />}>
                  <Route index element={<Dummy />} />

                  <Route path="shopping-cart" element={<ShoppingCart />} />
                  <Route path="order-completed" element={<Completed />} />
                </Route>
              </Route>

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ProductState>
    </UserState>
  </React.StrictMode>,
  document.getElementById("root")
);
